export { multiStringHandler } from './multi-string-handler'
export { productNameSizeHandler } from './product-name-size-handler'
export { generateBreadcrumbs } from './generate-product-data'
export { convertPastDaysToDate } from './covert-past-days-to-date'
